module.exports = __webpack_public_path__ + "static/user-521c556364162d9c4308c05b6c25214c.png";